export const en = {
  video: {
    startDialog: {
      start: 'Watch now',
      resume: 'Resume video',
      restart: 'Restart video',
      questions: '{{questions}} Questions',
      duration: '{{time}} min',
      credits: '{{credits}} Credits',
      colleaguesHint: {
        singular:
          'Another one of your colleagues has already watched the video, don’t fall behind!',
        plural: 'Over {{colleagues}} colleagues have already watched the video, don’t fall behind!',
      },
      errors: {
        noCredits: 'You do not have enough credits to start the video.',
      },
    },
    confirmExitFromVideoDialog: {
      title: 'Exit video',
      description:
        'If you close the video now, you’ll be able to resume it at any time from where you left off.',
      adminDescription:
        'If you close the video now, you won’t be able to resume from where you left off, but you can watch it again from the beginning as many times as you want.',
      confirm: 'Exit',
      cancel: 'Cancel',
    },
    feedbackVideoDialog: {
      title: 'How do you rate this video?',
      submittedTitle: 'Thanks for your feedback!',
      description: 'Rating is optional.',
      commentPlaceholder: 'Leave a comment to let us know your experience',
      submittedDescription: 'Continue with the training to not miss the next available content!',
      confirm: 'Submit',
      backToTraining: 'Back to training',
    },
  },
};
